// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"0a6be795","166":"99e6fdaa","611":"4fde44a6","706":"2da80f38","944":"0561cde8"}[chunkId] + ".chunk.css";
};